<template>
  <div>
    <div class="zj-tree-dailog">
      <el-tree
        ref="tree"
        style="{ width }"
        show-checkbox
        node-key="TreeId"
        :default-expanded-keys="expandkeys"
        :data="Menus"
        :props="defaultProps"
        highlight-current="true"
      ></el-tree>
    </div>
    <div style="text-align: center; padding-top: 30px">
      <el-button type="primary" @click="OnSubmit">提交</el-button>
      <el-button @click="OnCancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import utils from "../../../../../../utils";
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";

export default {
  name: "RoleMenusPage",
  data() {
    return {
      Menus: [],
      defaultProps: {
        children: "ChildTreeList",
        label: "TreeName",
      },
      expandkeys: [],
      newCheckedKeys: [],
    };
  },
  props: {
    Role_Id: {
      type: String,
      default: "",
    },
  },
  created: function () {
    this.init();
  },
  computed: {},
  methods: {
    init() {
      return utils.waitAll([() => this.GetMenus("")]);
    },
    GetMenus(expand_keys) {
      var OrgCode = this.config.app.org_code;

      let user = this.user;
      var userId = user.UserId;

      let RoleProductMenuSearch = {
        RoleId: this.Role_Id,
      };

      showLoading(".zj-form-container");

      return new WebApis.RoleProductMenuApi()
        .FindRoleMenuIds(RoleProductMenuSearch)
        .then((res) => {
          if (res.RspCode == "1") {
            var menuids = res.data.Data;
            let TreeSearch = {
              OrgCode: OrgCode,
              userId: userId,
            };

            new WebApis.TreeApi()
              .GetMenuTree(TreeSearch)
              .then((res) => {
                this.Menus = res.data.Data;
                this.expandkeys = expand_keys;
                menuids.forEach((item) => {
                  this.checked(item, this.Menus, this.newCheckedKeys);
                });
                this.$refs.tree.setCheckedKeys(this.newCheckedKeys);
                hideLoading();
              })
              .catch((e) => {
                console.log("获取菜单失败",e);
                hideLoading();
                this.$message({
                  showClose: true,
                  message: e.RspMsg
                    ? "获取菜单失败!" + e.RspMsg
                    : "获取菜单失败!",
                  type: "error",
                });
              });
          }
        });
    },
    checked(id, data, newCheckedKeys) {
      data.forEach((item) => {
        if (item.TreeId == id) {
          if (
            item.ChildTreeList == null ||
            item.ChildTreeList.length == 0
          ) {
            newCheckedKeys.push(item.TreeId);
          }
        } else {
          if (item.ChildTreeList != null && item.ChildTreeList.length != 0) {
            this.checked(id, item.ChildTreeList, newCheckedKeys);
          }
        }
      });
    },
    OnSubmit() {
      let user = this.user;
      var userId = user.UserId;
      const getParentCheckedKeys = this.$refs.tree.getHalfCheckedKeys();
      let getCheckedKeys = this.$refs.tree.getCheckedKeys();
      getCheckedKeys = getCheckedKeys.concat(getParentCheckedKeys);
      if (getCheckedKeys.length == 0) {
        getCheckedKeys.push("");
      }
      let RoleProductMenuSearch = {
        MenuStrList: getCheckedKeys,
        RoleId: this.Role_Id,
        UserId: userId,
      };
      showLoading(".zj-form-container");
      new WebApis.RoleProductMenuApi()
        .InsertRoleProductMenus(RoleProductMenuSearch)
        .then((res) => {
          if (res.RspCode == "1") {
            hideLoading();
            this.$message({
              showClose: true,
              message: "授权成功!",
              type: "success",
            });
            this.$emit("clickOk", {});
          }
          this.logInfo.ActionName = "角色授权";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "角色授权成功" : "角色授权失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "角色管理授权页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "权限分配失败!" + e.RspMsg : "权限分配失败!",
            type: "error",
          });
        });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
  },
};
</script>